<template>
    <div class="tabs">
        <ul class="tabs-links">
            <li v-for="tab in tabs" :class="{ 'active': tab.isActive }">
                <a :href="tab.href" @click="selectTab(tab)">{{ tab.title }}</a>
            </li>
        </ul>

        <div class="tabs-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabs: []
            };
        },
        created() {
            this.tabs = this.$children;
        },
        mounted() {
            if (this.tabs.length) {
                this.tabs[0].isActive = true;
            }
        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.id === selectedTab.id);
                });
            }
        }
    };
</script>
